<script>
    import LySection from '../components/LySection.svelte';

    /**
     * @type {{
     *     tag?: string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     padding?: boolean | string,
     *     children?: import("svelte").Snippet,
     *     [key: string]: any,
     * }}
     */
    let { tag = 'section', mt = 0, mb = 0, padding = false, children, ...restProps } = $props();
</script>

<LySection {...restProps} {mt} {mb} {tag} {padding}>
    {@render children?.()}
</LySection>
